<template>
  <NuxtLink v-if="link && componentType === LinkTypesEnum.nuxtLink" :to="link"><slot /></NuxtLink>
  <a v-else-if="link" :href="link"><slot /></a>
  <span v-else><slot /></span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi'
import { LinkTypes, LinkTypesEnum } from '@svoi-ui/interfaces/link-type'
import { isString } from '@svoi-ui/shared/utils/guards'

export default defineComponent({
  name: 'SvoiPaginationLink',
  props: {
    link: {
      type: String,
      default: undefined
    },
    componentType: {
      type: String as PropType<LinkTypes | string>,
      default: LinkTypesEnum.nuxtLink,
      validator: (value: unknown) => {
        return isString(value) && [LinkTypesEnum.a.toString(), LinkTypesEnum.nuxtLink.toString()].includes(value)
      }
    }
  },
  setup() {
    return { LinkTypesEnum }
  }
})
</script>
